import React from "react";
import Reading from "./readingbook.svg";

function ReadingBookIcon() {
  return <img src={Reading} alt="reading icon " />;
}

export default ReadingBookIcon;
